import React, { useEffect, useState } from "react";
import Checkbox from "../../components/inputs/checkbox";
import CustomSelect from "../../components/inputs/select";
import LayoutPresta from "./layoutPresta";
import { useDispatch, useSelector } from "react-redux";
import { create } from "../../services/services";
import {
  createEtablissementHoraires,
  getMyEtablissement,
} from "../../store/slices/etablissementSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { OpeningHoursForm } from "../../components/etablissement/horaires";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Horaires = () => {
  const { createStatus, selectedEtablissement } = useSelector(
    (state) => state.etablissements
  );
  useEffect(() => {
    dispatch(getMyEtablissement());
  }, []);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const transformHorairesToSchedules = (horaires) => {
    // Group by identical schedules
    const scheduleGroups = {};

    horaires?.forEach((horaire) => {
      const key = `${horaire.horaire_ouverture}-${horaire.horaire_fermeture}-${horaire.pause_debut}-${horaire.pause_fin}-${horaire.continuous}-${horaire.fermee}`;

      if (!scheduleGroups[key]) {
        scheduleGroups[key] = {
          days: [],
          opening: horaire.horaire_ouverture
            ? horaire.horaire_ouverture.substring(0, 5)
            : null,
          closing: horaire.horaire_fermeture
            ? horaire.horaire_fermeture.substring(0, 5)
            : null,
          pauseStart: horaire.pause_debut
            ? horaire.pause_debut.substring(0, 5)
            : null,
          pauseEnd: horaire.pause_fin
            ? horaire.pause_fin.substring(0, 5)
            : null,
          continuous: Boolean(horaire.continuous),
          closedAllDay: Boolean(horaire.fermee),
        };
      }

      // Capitalize first letter of day
      const day = horaire.jour.charAt(0).toUpperCase() + horaire.jour.slice(1);
      scheduleGroups[key].days.push(day);
    });

    // Convert to array and add IDs
    return Object.values(scheduleGroups).map((group, index) => ({
      id: index + 1, // or use Date.now() if you prefer
      ...group,
    }));
  };
  useEffect(() => {
    if (selectedEtablissement) {
      setSchedules(
        transformHorairesToSchedules(selectedEtablissement?.horaires)
      );
    }
  }, [selectedEtablissement]);
  // State pour les plages horaires enregistrées
  const [schedules, setSchedules] = useState([]);

  const formatSchedule = (schedule) => {
    const isClosed = schedule.closedAllDay;
    const isContinuous = schedule.continuous && !isClosed;

    return schedule.days.map((day) => ({
      jour: day.toLowerCase(),
      horaire_ouverture: isClosed ? null : schedule.opening,
      horaire_fermeture: isClosed ? null : schedule.closing,
      pauseStart: isClosed || isContinuous ? null : schedule.pauseStart,
      pauseEnd: isClosed || isContinuous ? null : schedule.pauseEnd,
      continuous: isContinuous,
      fermee: Boolean(isClosed),
    }));
  };

  const handleSubmit = async () => {
    const formattedSchedules = schedules.map((schedule) => {
      return formatSchedule(schedule); // ✅ Explicit return
    });
    const data = formattedSchedules.flat();
    // Dispatch the action and wait for it to complete
    // Only dispatch if there's data to save
    if (data.length > 0) {
      await dispatch(createEtablissementHoraires(data)).unwrap();
    } else {
      toast.error("Veuillez sélectionner au moins un jour");
      return;
    }
    const stepsStatus = JSON.parse(localStorage.getItem("stepsStatus")) || {};
    stepsStatus[3] = "completed";
    localStorage.setItem("stepsStatus", JSON.stringify(stepsStatus));
    // Navigate after successful creation
    navigate("/photos");
  };
  const handleSave = (updatedSchedules) => {
    setSchedules(updatedSchedules);
  };
  const isSubmitting = createStatus === 'loading';
  return (
    <LayoutPresta
      currentStep={3}
      nextStep={"/photos"}
      handleSubmit={handleSubmit}
      disabled={isSubmitting}
      btn={false}
    >
       <HelmetProvider>
                        <Helmet>
                          <title>Inscription Prestataire </title>
                          <meta
                            name="description"
                            content="Inscription Prestataire étape horaires d'ouverture"
                          />
                        </Helmet>
                      </HelmetProvider>
      <div className="col-md-6 col-xs-12 mx-auto mt-48">
        <OpeningHoursForm
          initialSchedules={schedules}
          onSave={handleSave}
          days={[
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi",
            "Dimanche",
          ]}
        />
      </div>
      <div className="ht-100"></div>
    </LayoutPresta>
  );
};

export default Horaires;
